import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { ExpansionPanel, Link, Typography } from 'components/alf-design';

const AccountVerificationHelp = ({ className }) => (
  <ExpansionPanel
    type="faq"
    className={clsx(
      'w-full max-w-[500px] overflow-hidden rounded-[10px] border border-legacy-borderLight p-px',
      className,
    )}
    id="account-verification-help"
    header={
      <Typography type="h3" component="span" className="text-legacy-dark">
        Having trouble verifying your account?
      </Typography>
    }
    contentClassName="!my-[10px]"
  >
    <div
      id="account-verification-help-content"
      className="flex flex-col gap-[12px]"
    >
      <Typography component="p" className="text-legacy-dark">
        It happens! The most common issue we see is that the information
        that&apos;s entered doesn&apos;t match the policy:
      </Typography>
      <ul className="my-[8px] list-disc pl-[20px]">
        <li>
          <Typography component="span" className="text-legacy-dark">
            First and last name
          </Typography>
        </li>
        <li>
          <Typography component="span" className="text-legacy-dark">
            Property zip code
          </Typography>
        </li>
        <li>
          <Typography component="span" className="text-legacy-dark">
            Policy number
          </Typography>
        </li>
      </ul>
      <Typography component="p" className="text-legacy-dark">
        If you are having difficulty verifying your information, make sure
        everything matches your policy documents{' '}
        <Typography component="span" className="font-bold text-legacy-dark">
          exactly
        </Typography>
        . This could include middle initials, designations, or suffixes.
        <br />
        <br />
      </Typography>
      <Typography component="p" className="text-legacy-dark">
        If you see anything inaccurate that you would like corrected, please
        contact your agent or Slide customer service at{' '}
        <Link type="primary" href="tel:800-748-2030">
          (800) 748-2030
        </Link>
        .
      </Typography>
    </div>
  </ExpansionPanel>
);

AccountVerificationHelp.propTypes = {
  className: PropTypes.string,
};

export default AccountVerificationHelp;
